import * as React from 'react';
import { Alert, Button, Col, Fade, Row } from 'reactstrap';
import { useScreenshot } from 'use-react-screenshot';
import { useAppDispatch } from '../../hooks/index';
import { ErrorData, sendErrorToDevelopers } from '../../redux/EventsSlice';
import { SerializedError } from "@reduxjs/toolkit";


const ErrorInformer = (props: any) => {

    const dispatch = useAppDispatch();

    const ref = React.createRef<any>();
    const [width, setWidth] = React.useState(500);
    const [image, takeScreenshot] = useScreenshot()
    const [isVisible, setIsVisible] = React.useState<boolean>(false);
    const [isCaptureVisible, setIsCaptureVisible] = React.useState<boolean>(false);
    const [currentError, setCurrentError] = React.useState<any>();

    const getImage = () => {
        takeScreenshot(ref.current);
        setIsCaptureVisible(true);
    }

    const onDismiss = () => {
        setIsVisible(false);
        setIsCaptureVisible(false);
        setCurrentError(null);
        props.setError(null);
    }

    const sendEmailAsync = async () => {

        let errorForEmail: ErrorData = {
            error: currentError,
            errorCapture: image
        }

        await dispatch(sendErrorToDevelopers(errorForEmail));
        onDismiss();
    }

    React.useEffect(() => {
        if (props.error != null) {
            setCurrentError(props.error);
            setIsVisible(true);
        }
        else {
            setIsVisible(false);
            setCurrentError(null);
        }
    }, [props]);


    return (
        <React.Fragment>
            <Row>
                <Col>
                    <Alert color="danger" isOpen={isVisible} toggle={onDismiss}>
                        <Row className="mb-0">
                            <Col md="3">
                                <h4 className="alert-heading">Something Went Wrong</h4>
                            </Col>
                            <Col md="2">
                                <Button onClick={sendEmailAsync}>Send Email</Button>
                            </Col>
                            <Col md="2">
                                <Button onClick={getImage}>
                                    Include Screenshot
                                </Button>
                            </Col>
                        </Row>
                        <hr />
                        <Row>
                            <Col>
                                <Fade in={isCaptureVisible}>
                                    <img width={width} src={image} alt={'Screenshot'} />
                                </Fade>
                            </Col>
                        </Row>
                        <hr />
                        <Row>
                            <Col>
                                <Row>
                                    <Col md="2">
                                        Code:
                                    </Col>
                                    <Col md="10">
                                        <p>
                                            {currentError ? currentError.code : ""}
                                        </p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="2">
                                        Stack Trace:
                                    </Col>
                                    <Col md="10">
                                        <p>
                                            {currentError ? currentError.stack : ""}
                                        </p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="2">
                                        Message:
                                    </Col>
                                    <Col md="10">
                                        <p>
                                            {currentError ? currentError.message : ""}
                                        </p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="2">
                                        Source:
                                    </Col>
                                    <Col md="10">
                                        <p>
                                            {currentError ? currentError.name : ""}
                                        </p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Alert>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div ref={ref}>
                        {props.children}
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}


export default ErrorInformer;